export default "__VITE_ASSET__v_nBfTKG__"